<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批流程管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack" style="margin-top: 10px"></el-page-header>
    <el-row :gutter="15">
      <el-col :span="12">
        <!-- 筛选 -->
        <el-card>
          <el-row class="title_row">
              <el-col>
                  <span class="title_class">信息筛选</span>
              </el-col>
          </el-row>
          <el-form :model="queryForm" label-width="90px" ref="queryFormRef">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item label="流程名称" prop="keyword">
                  <el-input v-model="queryForm.keyword" placeholder="请输入流程名称" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-button type="primary" @click="searchFn">查询</el-button>
              <el-button @click="resetFn">重置</el-button>
            </el-row>
          </el-form>
        </el-card>

        <!-- 列表 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
              <el-col :span="12">
                  <span class="title_class">流程列表</span>
              </el-col>
              <el-col :span="12" align="right">
                <el-button type="primary" @click="showDialog(null)">新增流程</el-button>
              </el-col>
          </el-row>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataList"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
            <el-table-column label="流程名称" min-width="200">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleViewNodes(scope.row)">{{ scope.row.processName }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="业务类型" prop="businessType" min-width="160">
              <template slot-scope="scope">{{ businessTypeFilter(scope.row.businessType) }}</template>
            </el-table-column>
            <el-table-column label="描述" prop="description" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" min-width="160"></el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="showDialog(scope.row)">编辑</el-button>
                <el-button type="text" size="small" style="color: #F56C6C" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForm.pageNum"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            style="margin-top: 20px"
          ></el-pagination>
        </el-card>
      </el-col>

      <!-- 右侧节点列表 -->
      <el-col :span="12">
        <el-card>
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">节点列表</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-button type="primary" size="small" @click="showNodeDialog">新增节点</el-button>
            </el-col>
          </el-row>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="nodeList"
            border
            stripe
            v-loading="nodeLoading"
          >
            <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
            <el-table-column label="节点名称" prop="nodeName" min-width="160"></el-table-column>
            <el-table-column label="节点类型" min-width="120">
              <template slot-scope="scope">{{ nodeTypeFilter(scope.row.nodeType) }}</template>
            </el-table-column>
            <el-table-column label="审批人类型" min-width="120">
              <template slot-scope="scope">{{ approverTypeFilter(scope.row.approverType) }}</template>
            </el-table-column>
            <el-table-column label="审批人">
              <template slot-scope="scope">
                <el-tag type="" size="mini" v-for="(item, j) in scope.row.erpSysUserList" :key="j">{{ item.userName }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="排序" prop="nodeSort" min-width="80"></el-table-column>
            <el-table-column label="操作" width="140" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="showNodeDialog(scope.row)">编辑</el-button>
                <el-button type="text" size="small" style="color: #F56C6C" @click="handleDeleteNode(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="!currentProcessId" style="text-align: center; color: #999; padding: 40px 0;">
            请点击左侧流程名称查看节点列表
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      @close="handleDialogClose"
    >
      <el-form :model="dialogForm" label-width="100px" ref="dialogFormRef" :rules="dialogRules">
        <el-form-item label="流程名称" prop="processName">
          <el-input v-model="dialogForm.processName" placeholder="请输入流程名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="业务类型" prop="businessTypeEnum">
          <el-select v-model="dialogForm.businessTypeEnum" placeholder="请选择业务类型" style="width: 100%">
            <el-option
              v-for="item in businessTypeList"
              :key="item.enumkey"
              :label="item.desc"
              :value="item.enumkey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="dialogForm.description" type="textarea" :rows="3" placeholder="请输入描述" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="dialogLoading" @click="submitDialog">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 新增/编辑节点弹窗 -->
    <el-dialog
      :title="nodeDialogTitle"
      :visible.sync="nodeDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      @close="handleNodeDialogClose"
    >
      <el-form :model="nodeDialogForm" label-width="110px" ref="nodeDialogFormRef" :rules="nodeDialogRules">
        <input type="hidden" v-model="nodeDialogForm.id">
        <input type="hidden" v-model="nodeDialogForm.processId">
        <el-form-item label="节点名称" prop="nodeName">
          <el-input v-model="nodeDialogForm.nodeName" placeholder="请输入节点名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="节点类型" prop="nodeType">
          <el-select v-model="nodeDialogForm.nodeType" placeholder="请选择节点类型" style="width: 100%">
            <el-option label="发起人" :value="1"></el-option>
            <el-option label="单人审批" :value="2"></el-option>
            <el-option label="会签" :value="3"></el-option>
            <el-option label="抄送" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批人类型" prop="approverType">
          <el-select v-model="nodeDialogForm.approverType" placeholder="请选择审批人类型" style="width: 100%" @change="handleApproverTypeChange">
            <el-option label="发起人" :value="0"></el-option>
            <el-option label="固定人" :value="1"></el-option>
            <el-option label="上级" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="nodeDialogForm.approverType === 1" label="审批人" prop="approverValue">
          <el-select
            v-model="nodeDialogForm.approverValue"
            multiple
            placeholder="请选择审批人"
            style="width: 100%"
          >
            <el-option
              v-for="item in approverList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="nodeSort">
          <el-input v-model="nodeDialogForm.nodeSort" placeholder="请输入排序数字" maxlength="5"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="nodeDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="nodeDialogLoading" @click="submitNodeDialog">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'templateApprovalManagement',
  data () {
    return {
      loading: false,
      dataList: [],
      total: 0,
      // 节点列表
      nodeList: [],
      nodeLoading: false,
      currentProcessId: null,
      // 节点弹窗
      nodeDialogVisible: false,
      nodeDialogLoading: false,
      nodeDialogTitle: '新增节点',
      nodeDialogForm: {
        id: null,
        processId: null,
        nodeName: '',
        nodeType: '',
        approverType: '',
        approverValue: [],
        nodeSort: 1
      },
      // 审批人列表
      approverList: [],
      // 业务类型列表
      businessTypeList: [],
      nodeDialogRules: {
        nodeName: [{ required: true, message: '请输入节点名称', trigger: 'blur' }],
        nodeType: [{ required: true, message: '请选择节点类型', trigger: 'change' }],
        approverType: [{ required: true, message: '请选择审批人类型', trigger: 'change' }]
      },
      queryForm: {
        keyword: '',
        pageNum: 1,
        pageSize: 10
      },
      // 弹窗
      dialogVisible: false,
      dialogLoading: false,
      dialogTitle: '新增流程',
      dialogForm: {
        id: null,
        processName: '',
        businessTypeEnum: '',
        description: ''
      },
      dialogRules: {
        processName: [{ required: true, message: '请输入流程名称', trigger: 'blur' }],
        businessTypeEnum: [{ required: true, message: '请选择业务类型', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getDataList()
    this.getBusinessTypeList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 点击流程名称查看节点列表
    handleViewNodes (row) {
      this.currentProcessId = row.id
      this.getNodeList(row.id)
    },
    getNodeList (processId) {
      this.nodeLoading = true
      this.$http.get('flow/node/list/' + processId).then((res) => {
        if (res.code === 200) {
          this.nodeList = res.data || []
        }
        this.nodeLoading = false
      }).catch(() => {
        this.nodeLoading = false
      })
    },
    showNodeDialog (row) {
      if (!this.currentProcessId) {
        this.$message.warning('请先选择流程')
        return
      }
      if (row) {
        this.nodeDialogTitle = '编辑节点'
        this.nodeDialogForm = {
          id: row.id,
          processId: row.processId || this.currentProcessId,
          nodeName: row.nodeName,
          nodeType: row.nodeType,
          approverType: row.approverType,
          approverValue: row.approverValue ? String(row.approverValue).split(',').map(v => Number(v)) : [],
          nodeSort: row.nodeSort
        }
      } else {
        this.nodeDialogTitle = '新增节点'
        this.nodeDialogForm = {
          id: null,
          processId: this.currentProcessId,
          nodeName: '',
          nodeType: '',
          approverType: '',
          approverValue: [],
          nodeSort: this.nodeList.length + 1
        }
      }
      this.$nextTick(() => {
        this.$refs.nodeDialogFormRef && this.$refs.nodeDialogFormRef.clearValidate()
      })
      this.nodeDialogVisible = true
    },
    handleNodeDialogClose () {
      this.$refs.nodeDialogFormRef && this.$refs.nodeDialogFormRef.resetFields()
    },
    submitNodeDialog () {
      this.$refs.nodeDialogFormRef.validate((valid) => {
        if (!valid) return
        this.nodeDialogLoading = true
        const params = { ...this.nodeDialogForm }
        // approverValue 多选数组转逗号分隔字符串
        if (Array.isArray(params.approverValue)) {
          params.approverValue = params.approverValue.join(',')
        }
        this.$http.post('flow/node/save', params).then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.nodeDialogVisible = false
            this.getNodeList(this.currentProcessId)
          } else {
            this.$message.error(res.msg || '保存失败')
          }
          this.nodeDialogLoading = false
        }).catch(() => {
          this.nodeDialogLoading = false
          this.$message.error('保存失败')
        })
      })
    },
    handleDeleteNode (row) {
      this.$confirm('确认删除该节点？', '提示', { type: 'warning' }).then(() => {
        this.$http.post('flow/node/' + row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getNodeList(this.currentProcessId)
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },
    nodeTypeFilter (val) {
      const map = { 1: '发起人', 2: '单人审批', 3: '会签', 4: '抄送' }
      return map[val] || '-'
    },
    approverTypeFilter (val) {
      const map = { 0: '发起人', 1: '固定人', 2: '上级' }
      return map[val] || '-'
    },
    handleApproverTypeChange (val) {
      if (val === 1) {
        this.nodeDialogForm.approverValue = []
        this.getApproverList()
      }
    },
    getApproverList () {
      this.$http.get('erp/queryUsableList').then((res) => {
        if (res.code === 200) {
          this.approverList = res.data || []
        }
      }).catch(() => {})
    },
    // 列表
    getDataList () {
      this.loading = true
      const params = {}
      if (this.queryForm.keyword) params.keyword = this.queryForm.keyword
      params.pageNum = this.queryForm.pageNum
      params.pageSize = this.queryForm.pageSize
      this.$http.get('flow/def/page', { params }).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data.list || []
          this.total = res.data.total || 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getDataList()
    },
    resetFn () {
      this.queryForm.keyword = ''
      this.queryForm.pageNum = 1
      this.$refs.queryFormRef && this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.queryForm.pageNum = 1
      this.getDataList()
    },
    handleCurrentChange (newPage) {
      this.queryForm.pageNum = newPage
      this.getDataList()
    },
    // 新增/编辑
    showDialog (row) {
      if (row) {
        this.dialogTitle = '编辑流程'
        this.dialogForm = {
          id: row.id,
          processName: row.processName,
          businessTypeEnum: row.businessType,
          description: row.description
        }
      } else {
        this.dialogTitle = '新增流程'
        this.dialogForm = {
          id: null,
          processName: '',
          businessTypeEnum: '',
          description: ''
        }
      }
      this.$nextTick(() => {
        this.$refs.dialogFormRef && this.$refs.dialogFormRef.clearValidate()
      })
      this.dialogVisible = true
    },
    handleDialogClose () {
      this.$refs.dialogFormRef && this.$refs.dialogFormRef.resetFields()
    },
    submitDialog () {
      this.$refs.dialogFormRef.validate((valid) => {
        if (!valid) return
        this.dialogLoading = true
        const params = { ...this.dialogForm }
        // TODO: 替换为实际接口
        const apiName = 'flow/def/save'
        this.$http.post(apiName, params).then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.getDataList()
          } else {
            this.$message.error(res.msg || '保存失败')
          }
          this.dialogLoading = false
        }).catch(() => {
          this.dialogLoading = false
          this.$message.error('保存失败')
        })
      })
    },
    // 删除
    handleDelete (row) {
      this.$confirm('确认删除该流程？', '提示', { type: 'warning' }).then(() => {
        this.$http.post('flow/def/' + row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getDataList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    }, // 业务类型映射
    businessTypeFilter (val) {
      const item = this.businessTypeList.find(b => b.enumkey === val)
      return item ? item.desc : '-'
    },
    getBusinessTypeList () {
      this.$http.get('flow/def/businessTypeList').then((res) => {
        if (res.code === 200) {
          this.businessTypeList = res.data || []
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
